export const HOME = "/";
export const HOTPOT_GUIDELINE = "/hotpot-guideline";
export const HOTPOT_SELECT_SOUP = "/hotpot-select-soup";
export const PRODUCTS = "/products";
